// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-d-flex > div,
.box {
  background-color: var(--surface-e);
  text-align: center;
  padding: 1rem;
  border-radius: 4px;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
}

.p-d-flex > div {
  width: 8rem;
}

i:not([class~=pi]) {
  background-color: var(--surface-b);
  color: var(--primary-color);
  font-family: Monaco, courier, monospace;
  font-style: normal;
  font-size: 12px;
  padding: 2px 4px;
  letter-spacing: 0.5px;
  border-radius: 3px;
  font-weight: 600;
  margin: 0 2px;
}

:host ::ng-deep pre[class*=language-] {
  box-shadow: none;
  border: 0 none;
}
:host ::ng-deep pre[class*=language-]:before, :host ::ng-deep pre[class*=language-]:after {
  display: none !important;
}
:host ::ng-deep pre[class*=language-] code {
  border-left: 10px solid var(--surface-d) !important;
  box-shadow: none !important;
  background: var(--surface-b) !important;
  margin: 1em 0;
  color: var(--text-color);
  font-size: 14px;
}
:host ::ng-deep pre[class*=language-] code .token.tag, :host ::ng-deep pre[class*=language-] code .token.keyword {
  color: #2196F3 !important;
}
:host ::ng-deep pre[class*=language-] code .token.attr-name, :host ::ng-deep pre[class*=language-] code .token.attr-string {
  color: #2196F3 !important;
}
:host ::ng-deep pre[class*=language-] code .token.attr-value {
  color: #4CAF50 !important;
}
:host ::ng-deep pre[class*=language-] code .token.punctuation {
  color: var(--text-color);
}
:host ::ng-deep pre[class*=language-] code .token.operator, :host ::ng-deep pre[class*=language-] code .token.string {
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/app/app.code.component.scss"],"names":[],"mappings":"AAAA;;EAEC,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,+GAAA;AACD;;AAEA;EACC,WAAA;AACD;;AAEA;EACC,kCAAA;EACA,2BAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AACD;;AAEA;EACC,gBAAA;EACA,cAAA;AACD;AACC;EACC,wBAAA;AACF;AAEC;EACC,mDAAA;EACA,2BAAA;EACA,uCAAA;EACA,aAAA;EACA,wBAAA;EACA,eAAA;AAAF;AAGG;EAEC,yBAAA;AAFJ;AAKG;EAEC,yBAAA;AAJJ;AAOG;EACC,yBAAA;AALJ;AAQG;EACC,wBAAA;AANJ;AASG;EAEC,uBAAA;AARJ","sourcesContent":[".p-d-flex > div,\r\n.box {\r\n\tbackground-color: var(--surface-e);\r\n\ttext-align: center;\r\n\tpadding: 1rem;\r\n\tborder-radius: 4px;\r\n\tbox-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);\r\n}\r\n\r\n.p-d-flex > div {\r\n\twidth: 8rem;\r\n}\r\n\r\ni:not([class~=\"pi\"]) {\r\n\tbackground-color: var(--surface-b);\r\n\tcolor: var(--primary-color);\r\n\tfont-family: Monaco, courier, monospace;\r\n\tfont-style: normal;\r\n\tfont-size: 12px;\r\n\tpadding: 2px 4px;\r\n\tletter-spacing: .5px;\r\n\tborder-radius: 3px;\r\n\tfont-weight: 600;\r\n\tmargin: 0 2px;\r\n}\r\n\r\n:host ::ng-deep pre[class*=\"language-\"] {\r\n\tbox-shadow: none;\r\n\tborder: 0 none;\r\n\r\n\t&:before, &:after {\r\n\t\tdisplay: none !important;\r\n\t}\r\n\r\n\tcode {\r\n\t\tborder-left: 10px solid var(--surface-d) !important;\r\n\t\tbox-shadow: none !important;\r\n\t\tbackground: var(--surface-b) !important;\r\n\t\tmargin: 1em 0;\r\n\t\tcolor: var(--text-color);\r\n\t\tfont-size: 14px;\r\n\r\n\t\t.token {\r\n\t\t\t&.tag,\r\n\t\t\t&.keyword {\r\n\t\t\t\tcolor: #2196F3 !important;\r\n\t\t\t}\r\n\r\n\t\t\t&.attr-name,\r\n\t\t\t&.attr-string {\r\n\t\t\t\tcolor: #2196F3 !important;\r\n\t\t\t}\r\n\r\n\t\t\t&.attr-value {\r\n\t\t\t\tcolor: #4CAF50 !important;\r\n\t\t\t}\r\n\r\n\t\t\t&.punctuation {\r\n\t\t\t\tcolor: var(--text-color);\r\n\t\t\t}\r\n\r\n\t\t\t&.operator,\r\n\t\t\t&.string {\r\n\t\t\t\tbackground: transparent;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
